import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-lightbulb-flash-fill',
    title: '広告戦略・プランニング',
    desc: 'データドリブンな戦略で、ブランドの本質を捉えた効果的な広告コミュニケーションを提供します。',
    color: '#38BDF8',
    bg: 'linear-gradient(135deg, #E0F7FF, #BAE6FD)',
    emoji: '💡',
  },
  {
    icon: 'ri-palette-fill',
    title: 'ブランディング',
    desc: 'ロゴから世界観まで、一貫したブランドアイデンティティを構築します。',
    color: '#F472B6',
    bg: 'linear-gradient(135deg, #FFF0F7, #FBCFE8)',
    emoji: '🎨',
  },
  {
    icon: 'ri-global-fill',
    title: 'デジタルマーケティング',
    desc: 'SNS・SEO・広告運用を統合し、ROI最大化を実現するデジタル戦略を展開します。',
    color: '#A3E635',
    bg: 'linear-gradient(135deg, #F3FFEA, #D9F99D)',
    emoji: '📱',
  },
  {
    icon: 'ri-megaphone-fill',
    title: 'PR・メディア対応',
    desc: 'プレスリリースからメディア露出の最大化まで、ブランド認知を高めます。',
    color: '#FB923C',
    bg: 'linear-gradient(135deg, #FFF7ED, #FED7AA)',
    emoji: '📣',
  },
  {
    icon: 'ri-video-fill',
    title: '映像・動画制作',
    desc: 'ブランドムービーからSNS動画まで、インパクトある映像コンテンツを制作します。',
    color: '#C084FC',
    bg: 'linear-gradient(135deg, #FAF5FF, #E9D5FF)',
    emoji: '🎬',
  },
  {
    icon: 'ri-layout-masonry-fill',
    title: 'クリエイティブ制作',
    desc: 'パンフレット・チラシ・バナーなど、あらゆる販促物をデザインします。',
    color: '#FBBF24',
    bg: 'linear-gradient(135deg, #FFFBEB, #FDE68A)',
    emoji: '✨',
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-24 overflow-hidden" style={{ background: '#F8F9FF' }}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Title */}
        <div className="text-center mb-16">
          <div
            className="inline-flex items-center gap-2 text-xs font-black px-5 py-2.5 rounded-full mb-6 uppercase tracking-wider"
            style={{ background: '#FFF0F7', color: '#F472B6' }}
          >
            <i className="ri-service-fill" />
            Services
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 leading-tight">
            私たちの
            <span
              style={{
                background: 'linear-gradient(135deg, #38BDF8, #F472B6, #FBBF24)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              サービス
            </span>
            ✨
          </h2>
          <p className="text-gray-500 mt-4 max-w-lg mx-auto text-sm leading-relaxed font-medium">
            戦略からクリエイティブまで、ワンストップでブランドの成長を応援します！
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {services.map((s) => (
            <div
              key={s.title}
              className="rounded-3xl p-7 group cursor-default hover:-translate-y-1 transition-transform duration-300"
              style={{ background: s.bg }}
            >
              <div
                className="text-4xl mb-4 w-14 h-14 flex items-center justify-center rounded-2xl bg-white"
              >
                {s.emoji}
              </div>
              <h3 className="font-black text-gray-900 text-lg mb-3">{s.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 font-black px-8 py-3.5 rounded-full cursor-pointer hover:scale-105 transition-all whitespace-nowrap text-white"
            style={{ background: 'linear-gradient(135deg, #F472B6, #FBBF24)' }}
          >
            全サービスを見る
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
